import { ArrowRight, Phone } from "lucide-react";

export default function CTABand() {
  return (
    <section
      data-testid="cta-band"
      className="bg-stone-900 text-stone-50 py-20 lg:py-28 relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1100px] h-[500px] rounded-full opacity-25 blur-[160px] pointer-events-none"
        style={{
          background: "radial-gradient(circle, rgba(234,88,12,0.8) 0%, rgba(234,88,12,0) 70%)",
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 text-xs font-semibold text-orange-400 mb-4">
              <span className="w-1.5 h-1.5 bg-orange-500 rounded-full animate-pulse-dot" />
              NOW BOOKING SPRING 2026
            </div>
            <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.025em]">
              Ready for
              <br />
              <span className="text-orange-400">flooring done right?</span>
            </h2>
            <p className="mt-6 text-stone-300 text-lg max-w-xl">
              Free consultation for LVP · laminate · tile installation.
              Honest pricing. Most flooring jobs scheduled within 3 weeks.
            </p>
            <div
              data-testid="cta-discount-pill"
              className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-500/15 border border-orange-400/30 text-orange-200 text-sm font-semibold"
            >
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-orange-500 text-stone-900 text-xs font-bold">
                %
              </span>
              Ask about our 20% discount on materials
            </div>
          </div>
          <div className="lg:col-span-5 flex flex-col sm:flex-row lg:flex-col xl:flex-row gap-3 lg:justify-end">
            <a
              href="#contact"
              data-testid="cta-band-button"
              className="group inline-flex items-center justify-center gap-2 px-7 py-4 bg-orange-500 text-stone-50 font-semibold rounded-full hover:bg-stone-50 hover:text-stone-900 transition-all duration-300"
            >
              Request Free Quote
              <ArrowRight
                size={18}
                className="group-hover:translate-x-1 transition-transform"
              />
            </a>
            <a
              href="tel:+16368496681"
              data-testid="cta-band-phone"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-transparent border border-stone-50/30 text-stone-50 font-semibold rounded-full hover:bg-stone-50/10 transition-all"
            >
              <Phone size={16} strokeWidth={2.25} />
              636-849-6681
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
